import axios from 'axios'

const install = (Vue, { baseURL, interceptor }) => {
  const instance = axios.create({
    baseURL
  })
  if (interceptor) {
    interceptor(instance)
  }
  Object.defineProperties(Vue.prototype, {
    $http: {
      get() {
        return instance
      }
    }
  })
}

export default install